var new_fieldname = ""
var LblnVerificarCheck=false;
var LstrMensajeTotal="";


function check(form)
{
LstrMensajeTotal = "";
var strPrefijo = "";
var strPref = "";
var fieldname = "";
var fieldnamedfield = "";
var intLen=0;
var i=0;
var index=0;
var indexPref=0;

intLen = form.elements.length - 1
for (var i = 0; i <= intLen; i++)
	{
	if (form.elements[i].id!="")
		{

		Cleanfield(form, form.elements[i].id);

		strPrefijo = form.elements[i].id.substring(0, index + 1)
		fieldname = form.elements[i].id;

		indexPref = strPrefijo.indexOf('_')

		if (indexPref > 0)
            {
            fieldname = form.elements[i].id.substring(indexPref + 1);
            strPref = strPrefijo.substring(0, indexPref + 1);
            }
		else
		    strPref = '';

		//Campos din�micos
		fieldnamedfield = form.elements[i].id;
		if (fieldnamedfield.indexOf('r_dfield_') >= 0
        || fieldnamedfield.indexOf('i_dfield_') >= 0
        || fieldnamedfield.indexOf('f_dfield_') >= 0
        || fieldnamedfield.indexOf('d_dfield_') >= 0
        || fieldnamedfield.indexOf('e_dfield_') >= 0
        || fieldnamedfield.indexOf('interval_dfield_') >= 0
        || fieldnamedfield.indexOf('maxlength_dfield_') >= 0) {
		    strPref = '';
		    fieldname = 'dfield_' + fieldnamedfield.substring(9);
		}

		indexPref = strPrefijo.indexOf('field_');
		if (indexPref == 0) {
		    strPref = '';
		    fieldname = form.elements[i].id;
		}

		if (document.getElementById('r_' + fieldname) != null)
		    r_requerido(form, '', fieldname);

		if (document.getElementById('i_' + fieldname) != null) 
			i_check(form,'',fieldname)

		if (document.getElementById('f_' + fieldname) != null) 
			f_check(form,'',fieldname)

		if (document.getElementById('d_' + fieldname) != null) 
			d_check(form,intLen,'',fieldname,i)

		if (document.getElementById('e_' + fieldname) != null) 
			e_check(form,'',fieldname,i)

		if (fieldname.indexOf('interval:') > 0) 
			interval_check(form,'',fieldname)

		if (document.getElementById('maxlength_' + fieldname) != null) 
			maxlength_check(form,'',fieldname)
		}	
	}

if (LstrMensajeTotal != "") 
	return LstrMensajeTotal.replace(/\n/g,"<br>")
//return "Los siguientes datos estan incorrectos o incompletos :\n\n" + LstrMensajeTotal + "\n\n Complete los datos correctamente y trate nuevamente."
else
	return "";
}	

//***********************************************************************
function Cleannumericfield(form)
{
var strPrefijo = ""	
var strPref = ""	
var fieldname = ""
var intLen;
var i;
var index;
var indexPref;

intLen = form.elements.length - 1
		
for (var i = 0; i <= intLen; i++)
	{
	index=form.elements[i].id.indexOf('_')


	if (form.elements[i].id!="")
		{
		strPrefijo = form.elements[i].id.substring(0, index + 1)
		fieldname = form.elements[i].id;

		indexPref = strPrefijo.indexOf('_')
		if (indexPref > 0) {
		    fieldname = form.elements[i].id.substring(indexPref + 1)
		    strPref = strPrefijo.substring(0, indexPref + 1);
		}
		else
		    strPref = '';

		indexPref = strPrefijo.indexOf('field_');
		if (indexPref==0) {
		    strPref = '';
		    fieldname = form.elements[i].id;
		}

		if (document.getElementById(strPref + 'i_' + fieldname) != null)
		    onfocusnumericfield(document.getElementById(strPref + fieldname))

		else if (document.getElementById(strPref + 'f_' + fieldname) != null) {
		    onfocusnumericfield(document.getElementById(strPref + fieldname));
		    //document.getElementById(strPref + fieldname).value = document.getElementById(strPref + fieldname).value.replace(",", ".");
		    //alert(document.getElementById(strPref + fieldname).value);
		}
		}
	}
}

//***********************************************************************
function Cleanfield(form,fieldname)
{
var strField;
//Hay error aqu� cuando existen campos con nombres repetidos
//if (document.getElementById(fieldname).type==null)
if (document.getElementById(fieldname).type.toString().indexOf('textarea') == -1)
    if (fieldname != '' && fieldname != null && document.getElementById(fieldname).name != null)
		{
		strField = document.getElementById(fieldname).value;

		while(strField.indexOf ("'", 0)>-1)
			strField = strField.replace("'","");

		document.getElementById(fieldname).value = strField;
		}
}

//***********************************************************************
function r_requerido(form,strPref,fieldname)
{
var strMsg = "";

if ((document.getElementById(strPref + fieldname).type == "radio" || document.getElementById(strPref + fieldname).type == "checkbox") && document.getElementById(strPref + fieldname).checked == true)
	strMsg = ""

else if ((document.getElementById(strPref+fieldname).type == "radio" || document.getElementById(strPref+fieldname).type == "checkbox") && document.getElementById(strPref+fieldname).checked == false)
	strMsg = document.getElementById("r_" + fieldname).innerHTML

else if (document.getElementById(strPref+fieldname).type == "select-one")
	{
	var l = document.getElementById(strPref+fieldname).selectedIndex
	if (document.getElementById(strPref+fieldname).options[l].value != "")
		strMsg = ""

	else if (document.getElementById(strPref+fieldname).options[l].value == "")
		strMsg = document.getElementById(strPref+"r_" + fieldname).innerHTML

	}

else if (document.getElementById(strPref+fieldname).value == "" && document.getElementById(strPref+fieldname).type != "radio" && document.getElementById(strPref+fieldname).type != "checkbox" && document.getElementById(strPref+fieldname).type != "select-one")
		strMsg = document.getElementById(strPref+"r_" + fieldname).innerHTML

else if (document.getElementById(strPref+fieldname).value != "" && document.getElementById(strPref+fieldname).type != "radio" && document.getElementById(strPref+fieldname).type != "checkbox" && document.getElementById(strPref+fieldname).type != "select-one")
		strMsg = ""

MarcarErr(document.getElementById(strPref+fieldname),strMsg!='')


if (strMsg != "")
	{
	document.getElementById('r_'+fieldname).style.display="";
    LstrMensajeTotal = LstrMensajeTotal + "\n" + strMsg;
	}
else
	document.getElementById('r_'+fieldname).style.display="none";

return (strMsg);
}

//***********************************************************************
function i_check(form,strPref,fieldname)
{
var strMsg = ""
var i;
var strChar;
var inputStr;

if (document.getElementById(strPref+fieldname).value=='')
	return('');

inputStr = document.getElementById(strPref+fieldname).value.toString()
if (inputStr == "")
	strMsg = document.getElementById(strPref+"i_" + fieldname).innerHTML
else
	{
	for (i = 0; i < inputStr.length; i++)
		{
		strChar = inputStr.charAt(i)
		if ((strChar < "0" || strChar > "9") && strChar!='.')	strMsg = document.getElementById(strPref+"i_" + fieldname).innerHTML
		}
	}

MarcarErr(document.getElementById(strPref+fieldname),strMsg!='')

if (strMsg != "")
	{
	document.getElementById('i_'+fieldname).style.display="";
    LstrMensajeTotal = LstrMensajeTotal + "\n" + strMsg;
	}
else
	document.getElementById('i_'+fieldname).style.display="none";

return (strMsg);
}


function interval_check(form, strPref, fieldname) {
    var strMsg = "";
    var strPrefInterval = "";
    var inputStr;

    index = fieldname.indexOf('interval:');
    strFieldName = fieldname.substring(index);
    strValues = strFieldName;
    strFieldName = fieldname.substring(0, index);
    strFieldName = strFieldName.replace('interval_', '');

    strValues = strValues.replace('interval:', '');
    index = strValues.indexOf('_');

    strMin = strValues.substring(0, index);
    strMax = strValues.substring(index + 1);

    if (strPref.indexOf('interval_') == 0) {
        strPrefInterval = strPref.replace('interval_', '');
        if (document.getElementById(strPrefInterval + strFieldName).value == '')
            return ('');

        inputStr = document.getElementById(strPrefInterval + strFieldName).value.toString()
        inputStr = inputStr.replace('.', '').replace('.', '')
        inputStr = inputStr.replace(',', '.')

        if (isNaN(inputStr) || inputStr == "")
            strMsg = document.getElementById(strPref + fieldname).value
        else if (eval(strMin) > eval(inputStr) || eval(strMax) < eval(inputStr))
            strMsg = document.getElementById(strPref + fieldname).value

        MarcarErr(document.getElementById(strPrefInterval + strFieldName), strMsg != '')
        if (strMsg != "")
            if (LstrMensajeTotal == "")
                LstrMensajeTotal = strMsg
            else
                LstrMensajeTotal = LstrMensajeTotal + "\n" + strMsg;
    }
    else {

        if (document.getElementById(strPref + strFieldName).value == '')
            return ('');

        inputStr = document.getElementById(strPref + strFieldName).value.toString()
        inputStr = inputStr.replace('.', '').replace('.', '')
        inputStr = inputStr.replace(',', '.')

        if (isNaN(inputStr) || inputStr == "")
            strMsg = document.getElementById(strPref + fieldname).value
        else if (eval(strMin) > eval(inputStr) || eval(strMax) < eval(inputStr))
            strMsg = document.getElementById(strPref + fieldname).value

        MarcarErr(document.getElementById(strPref + strFieldName), strMsg != '')
        if (strMsg != "")
            if (LstrMensajeTotal == "")
                LstrMensajeTotal = strMsg
            else
                LstrMensajeTotal = LstrMensajeTotal + "\n" + strMsg;
    }

return (strMsg);
}	

//***********************************************************************
function interval_checkANTERIOR(form,strPref,fieldname)
{
var strMsg = ""
var strPrefInterval = ""

index = fieldname.indexOf('interval:');
strFieldName = fieldname.substring(index);
strValues = strFieldName;
strFieldName = fieldname.substring(0, index);
strFieldName = strFieldName.replace('interval', '');

strValues = strValues.replace('interval:', '');
index = strValues.indexOf('_');

strMin = strValues.substring(0, index);
strMax = strValues.substring(index + 1);

if (strPref.indexOf('interval') == 0) {
    strPrefInterval = strPref.replace('interval', '');
    if (document.getElementById(strPrefInterval + strFieldName).value == '')
        return ('');

    inputStr = document.getElementById(strPrefInterval + strFieldName).value.toString()
    inputStr = inputStr.replace(',', '.')

    if (isNaN(inputStr) || inputStr == "")
        strMsg = document.getElementById(strPref + fieldname).value
    else if (eval(strMin) > eval(inputStr) || eval(strMax) < eval(inputStr))
        strMsg = document.getElementById(strPref + fieldname).value

    MarcarErr(document.getElementById(strPrefInterval + strFieldName), strMsg != '')
    if (strMsg != "")
        if (LstrMensajeTotal == "")
            LstrMensajeTotal = strMsg
        else
            LstrMensajeTotal = strMensajeTotal + "\n" + strMsg;

}
else {
    if (document.getElementById(strPref + strFieldName).value == '')
        return ('');

    inputStr = document.getElementById(strPref + strFieldName).value.toString()
    inputStr = inputStr.replace(',', '.')

    if (isNaN(inputStr) || inputStr == "")
        strMsg = document.getElementById(strPref + fieldname).value
    else if (eval(strMin) > eval(inputStr) || eval(strMax) < eval(inputStr))
        strMsg = document.getElementById(strPref + fieldname).value

    MarcarErr(document.getElementById(strPref + strFieldName), strMsg != '')
    if (strMsg != "")
        if (LstrMensajeTotal == "")
            LstrMensajeTotal = strMsg
        else
            LstrMensajeTotal = strMensajeTotal + "\n" + strMsg;

    }

}	

//***********************************************************************
function maxlength_check(form,strPref,fieldname)
{
var strMsg = ""

index=fieldname.indexOf('_field_')
if (index<0)
	index=fieldname.indexOf('_dfield_')

strFieldName=fieldname.substring(index+1)
strMax=fieldname.substring(0,index)

if (document.getElementById(strPref+strFieldName).value=='')
	return('');

inputStr = document.getElementById(strPref+strFieldName).value.toString()
if (eval(strMax)< document.getElementById(strPref+strFieldName).value.length)
	strMsg=document.getElementById(strPref+"maxlength_"+strMax+'_'+strFieldName).value

MarcarErr(document.getElementById(strPref+strFieldName),strMsg!='')
if (strMsg != "")
    if (LstrMensajeTotal == "")
        LstrMensajeTotal = strMsg
    else
        LstrMensajeTotal = LstrMensajeTotal + "\n" + strMsg;

return (strMsg);
}	

//***********************************************************************
function f_check(form,strPref,fieldname)
{
var strMsg = ""
var decimal = ""
var strChar

if (document.getElementById(strPref+fieldname).value=='')
	return('');

inputStr = document.getElementById(strPref+fieldname).value.toString()
if (inputStr == "")
	strMsg = document.getElementById(strPref+"f_" + fieldname).value

else

	for (i = 0; i < inputStr.length; i++)
		{
		strChar = inputStr.charAt(i)
		if (i == 0 && strChar == "-" || strChar == "," && decimal == "")
			{
			if (strChar == ",")
				decimal = "yes"
			}
		else if (strChar < "0" || strChar > "9")	strMsg = document.getElementById(strPref+"f_" + fieldname).value
		}
MarcarErr(document.getElementById(strPref+fieldname),strMsg!='')
if (strMsg != "")
    if (LstrMensajeTotal == "")
        LstrMensajeTotal = strMsg
    else
        LstrMensajeTotal = LstrMensajeTotal + "\n" + strMsg;

return (strMsg);
}
	
//***********************************************************************
function e_check(form,strPref,fieldname,i)
{
	
var strMsg = ""
var blnError = false;
var intTest;
var inputStr;
var new_length;

if (document.getElementById(strPref+fieldname).value=='')
	return('');

inputStr = document.getElementById(strPref+fieldname).value.toString()

if (inputStr=='')
	return('');

if (inputStr == "" || inputStr.indexOf ('@', 0) < 3)
	blnError = true;

intTest = inputStr.indexOf('.', inputStr.indexOf ('@', 0));
if (intTest==-1)
	blnError = true;

if (blnError)
	strMsg = document.getElementById(strPref+"e_" + fieldname).innerHTML
			
else
    {
	new_length = inputStr.length - intTest
	if (new_length == 4 || new_length == 3 || (new_length >= 5 && inputStr.indexOf ('.', (intTest+1)) != -1))
		strMsg = ""
	else
		strMsg = document.getElementById(strPref+"e_" + fieldname).innerHTML;

	}

MarcarErr(document.getElementById(strPref+fieldname),strMsg!='')

if (strMsg != "")
	{
	document.getElementById('e_'+fieldname).style.display="";
    LstrMensajeTotal = LstrMensajeTotal + "\n" + strMsg;
	}
else
	document.getElementById('e_'+fieldname).style.display="none";

return (strMsg);

}	

//***********************************************************************
function d_check(form,intLen,strPref,fieldname,i)
//Formato : DD/MM/YY
{
if (document.getElementById(strPref+fieldname).value=='')
	return('');

for (var y = 0; y <= intLen; y++)
	{
	if (form.elements[y].name == strPref+fieldname)
	break
	}		
			
var strMsg = ""	
var sDate = form.elements[y].value

if (isNatural(sDate.substring(0,2)) && sDate.substring(2,3)=="/" 
	&& isNatural(sDate.substring(3,5)) && sDate.substring(5,6)=="/" 
	&& isNatural(sDate.substring(6,10)))
	{
	    if (!((sDate.substring(0, 2) * 1) >= 1 && (sDate.substring(0, 2) * 1) <= 31
	&& (sDate.substring(3, 5) * 1) >= 1 && (sDate.substring(3, 5) * 1) <= 12
	&& (sDate.substring(6, 10) * 1) >= 1900 && (sDate.substring(6, 10) * 1) <= 2025
	&& (sDate.substring(0, 2) * 1 <= howmanydays(sDate.substring(3, 5) * 1, sDate.substring(6, 10) * 1))))
		strMsg = form.elements[i].value
	} 
	else
		msg_addition = form.elements[i].value

MarcarErr(document.getElementById(strPref+fieldname),strMsg!='')
if (strMsg != "")
    if (LstrMensajeTotal == "")
        LstrMensajeTotal = strMsg
    else
        LstrMensajeTotal = LstrMensajeTotal + "\n" + strMsg;

return (strMsg);
}

function howmanydays(mes, anyo)
	{	
    var hmd = 31;
    if (mes == 4 || mes == 6 || mes == 9 || mes == 11)
		hmd = 30;
    if (mes == 2 && (anyo/4) != Math.floor(anyo/4))
		hmd = 28;
    if (mes == 2 && (anyo/4) == Math.floor(anyo/4))
		hmd = 29;
    
    return hmd;
	}

//***********************************************************************
function isInteger(sDate)
{
var blnInteger = true
var inputStr = sDate.toString()

for (var i = 0; i < inputStr.length; i++)
	{
	var oneChar = inputStr.charAt(i)			
	if ((oneChar < "0" || oneChar > "9") && oneChar != "-" && i!=0)
		blnInteger = false
	}

return (blnInteger)
}
	
//***********************************************************************
function isNatural(sIn)
{
var blnInteger = true;
var blnNatural=true;

inputStr = sIn.toString()

for (var i = 0; i < inputStr.length; i++)
	{
	var oneChar = inputStr.charAt(i)			
	if ((oneChar < "0" || oneChar > "9") && oneChar != "/")
		blnNatural = false
	}

return (blnNatural)
}

//***********************************************************************
function asc(each_char)
{
var n = 0
var char_str = charSetStr()

for (i = 0; i < char_str.length; i++)
	{
	if (each_char == char_str.substring(i, i+1))
		break

	}

return (i + 32)
}
		
//***********************************************************************
function charSetStr()
{
var str

str = ' !"#$%&' + "'" + '()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~'
return (str)
}


//***************************************************************
//*****************       Rut      ******************************
//***************************************************************
function digitoVerificador(strRut) {

    var Largo, LargoN, i, Total;
    var Numero="", Verif, Carac, CaracVal;
    var tmpRut,intTmp;
    
    tmpRut = strRut
    Largo = tmpRut.length
    LargoN = 0
    for(i=0;i<Largo;i++) {
        Carac = parseInt(tmpRut.charAt(i),10);
        if(Carac >=0 && Carac <=9) {
			Numero+=tmpRut.charAt(i);
            LargoN++;
	 	}
    }

	Total=0;
    for(i=LargoN-1;i>=0;i--) {
		if((LargoN - i) < 7) {
		   intTmp=LargoN - i + 1;
		} else {
		   intTmp=LargoN - i - 5;
		}
        Total+= parseInt(Numero.charAt(i),10) * intTmp 
    }
    
    CaracVal = 11 - (Total % 11)
    
    if(CaracVal==10) {
       return('K');
	}
	
	if(CaracVal >=0 && CaracVal <=9) {
       return(CaracVal);
	}
	
	if(CaracVal==11) {
	   return(0);
    }
}

function esRutValido(strRut,strDigito) {
var digVerif;
digVerif = digitoVerificador(strRut)

return(digVerif == strDigito || (strDigito=="k" && digVerif=="K"))
}

function ValidaRut(objField)
{
if(objField.value.length>1)
    {
    strDV=objField.value.substr(objField.value.length-1,1)
    strRut=objField.value.substr(0,objField.value.length-1)
    if(esRutValido(strRut,strDV)==true)
        return true
    else
        alert('Rut incorrecto')
    }
else if(objField.value.length==1)
    alert('Rut incorrecto')
else
    return true
}

function onblurRut(intTipo,field)
{
var objRut;

if (document.getElementById('field_' + field.name) != null)
    objRut = document.getElementById('field_' + field.id);
else if (document.getElementById('mt_field_' + field.id) != null)
    objRut = document.getElementById('mt_field_' + field.id);
else
	objRut=document.getElementById('fc_'+field.name);

if (field.value != '' && objRut.value == '')
	{
	strValue=Limpiarut(field.value);
	objRut.value=strValue.toUpperCase();

	var strDV = strValue.substring(strValue.length-1,strValue.length);
	var strRut = strValue.substring(0,strValue.length-1);

	if (intTipo!=2)
	{
	if (intTipo==1 && strRut<50000000)
		{
		field.value='';
		objRut.value='';
		strRut='';
		//alert('Rut no valido para persona juridica');
		alert('Rut no valido');
		return;
		}
	
	if (intTipo==0 && strRut>50000000)
		{
		document.getElementById(field.id).value = '';
		objRut.value='';
		strRut='';
		//alert('Rut no valido para persona natural');
		alert('Rut no valido');
		return;
		}
	}
	
	var i=strRut.length;
	var strValueret='';
	while (i>0)
		{
		strValueret=strRut.substring(i-3,i)+'.'+strValueret;
		i=i-3;
		}
	strValueret=strValueret.substring(0,strValueret.length-1)+'-'+strDV;
	strValueret=strValueret.toUpperCase();
	field.value =strValueret;
	}
	else MarcarErr(field,false);
}

function Limpiarut(strValue)
{
strValueret='';
i=strValue.length;
while (i>0)
	{
	if (strValue.substring(i-1,i)!='.' && strValue.substring(i-1,i)!='-')
		strValueret=strValue.substring(i-1,i)+strValueret;
	i-=1;
	}
return strValueret;
}
//***************************************************************
//***************************************************************

function MarcarErr(field,blnErr)
{
if (blnErr)
	field.style.border='1 solid #FF0000';
else
	field.style.border='1 solid #777777';
}

function onblurnumericfield(field)
{
var strValue;
var strValueret;
var i;

strValue=field.value;
strValueret='';
i=strValue.length;

while (i>0)
	{
	strValueret=strValue.substring(i-3,i)+'.'+strValueret;
	i=i-3;
	}

if (isInteger(field.value))
	field.value =strValueret.substring(0,strValueret.length-1);
else
	MarcarErr(field,true);
}

function onfocusnumericfield(field)
{
var strValue;
var i;
var strValueret;

strValue=field.value;
strValueret='';
i=strValue.length;
while (i>0)
	{
//	alert(strValue.substring(i-3,i));
	if (strValue.substring(i-1,i)!='.')
		strValueret=strValue.substring(i-1,i)+strValueret;
	i-=1;
	}

field.value =strValueret;
}

function onblurrequiredfield(field)
{
MarcarErr(field,field.value=='')
}

function checkEnter(e){
var characterCode

if(e && e.which)
	{
	e = e
	characterCode = e.which
	}
else
	{
	e = event
	characterCode = e.keyCode
	}	 

if(characterCode == 13)
	return true

return false
}



export {
	check,
	onblurRut,
	ValidaRut,
	Cleannumericfield,
	onblurnumericfield,
	onfocusnumericfield

}
